<template>
  <div class="container py-5">
    <h2 class="mb-3">Candidatos da Vaga</h2>

    <div v-if="vaga">
      <h4 class="text-secondary">
        {{ vaga.titulo }} - publicada em: {{ formatarDataBrasileira(vaga.data_publicacao) }}
      </h4>
      <p>

        <span :class="['badge px-5 py-2', vaga.statuss === 'aberta' ? 'bg-success' : 'bg-secondary']">
          {{ vaga.statuss }}
        </span>
      </p>
      <p>
        Prazo:
        <span>
          {{ vaga.prazo ? formatarData(vaga.prazo) : '-' }}
        </span>
      </p>
    </div>

    <button class="btn btn-success mb-3" @click="baixarXLSX">
      Baixar tabela como XLSX
    </button>

    <!-- Adicione o botão ao lado do botão XLSX -->
<button class="btn btn-primary mb-3 ms-2" @click="baixarTodosCurriculos" :disabled="candidatosFiltrados.length === 0">
  Baixar todos os currículos (.zip)
</button>

    <div v-if="candidatos.length" class="table-responsive" style="overflow-x: auto;">
      <!-- Tabela incrementada -->
      <table class="table table-bordered table-striped align-middle">
        <thead>
          <tr>
            <!-- Cabeçalho já existente -->
            <th>Nome</th>
            <th>Avaliação</th>
            <th>Email</th>
            <th>Currículo</th>
            <th>Data da Candidatura</th>
            <!-- Novas colunas incrementadas -->
            <th>Telefone</th>
            <th>CPF</th>
            <th>Endereço</th>
            <th>Cidade</th>
            <th>Estado</th>
            <th>Formação</th>
            <th>Escolaridade</th>
            <th>Experiência</th>
            <th>Gênero</th>
            <th>Raça</th>
            <th>Pessoa com deficiência</th>
            <th>Nome Social</th>
            <th>Naturalidade</th>
            <th>Está trabalhando atualmente?</th>
            <th>Data de Nascimento</th>
            <th>Pretensão Salarial</th>
            <!-- Outras colunas já existentes, como ações -->
            <th>Ações</th>
          </tr>
          <tr>
            <th><input v-model="filtros.nome" class="form-control form-control-sm" placeholder="Filtrar Nome"></th>
            <th></th>
            <th><input v-model="filtros.email" class="form-control form-control-sm" placeholder="Filtrar Email"></th>
            <th></th>
            <th><input v-model="filtros.data_candidatura" class="form-control form-control-sm"
                placeholder="Filtrar Data"></th>
            <th><input v-model="filtros.telefone" class="form-control form-control-sm" placeholder="Filtrar Telefone">
            </th>
            <th><input v-model="filtros.cpf" class="form-control form-control-sm" placeholder="Filtrar CPF"></th>
            <th><input v-model="filtros.endereco" class="form-control form-control-sm" placeholder="Filtrar Endereço">
            </th>
            <th><input v-model="filtros.cidade" class="form-control form-control-sm" placeholder="Filtrar Cidade"></th>
            <th><input v-model="filtros.estado" class="form-control form-control-sm" placeholder="Filtrar Estado"></th>
            <th><input v-model="filtros.formacao" class="form-control form-control-sm" placeholder="Filtrar Formação">
            </th>
            <th><input v-model="filtros.escolaridade" class="form-control form-control-sm"
                placeholder="Filtrar Escolaridade"></th>
            <th><input v-model="filtros.experiencia" class="form-control form-control-sm"
                placeholder="Filtrar Experiência"></th>
            <th><input v-model="filtros.genero" class="form-control form-control-sm" placeholder="Filtrar Gênero"></th>
            <th><input v-model="filtros.raca" class="form-control form-control-sm" placeholder="Filtrar Raça"></th>
            <th><input v-model="filtros.deficiencia" class="form-control form-control-sm"
                placeholder="Filtrar Deficiência"></th>
            <th><input v-model="filtros.nome_social" class="form-control form-control-sm"
                placeholder="Filtrar Nome Social"></th>
            <th><input v-model="filtros.naturalidade" class="form-control form-control-sm"
                placeholder="Filtrar Naturalidade"></th>
            <th><input v-model="filtros.trabalhando_atualmente" class="form-control form-control-sm"
                placeholder="Filtrar Trabalho"></th>
            <th><input v-model="filtros.data_nascimento" class="form-control form-control-sm"
                placeholder="Filtrar Nascimento"></th>
            <th><input v-model="filtros.pretensao_salarial" class="form-control form-control-sm"
                placeholder="Filtrar Salário"></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="candidato in candidatosFiltrados" :key="candidato.id">
            <!-- Colunas já existentes -->
            <td>
              {{ candidato.nome }} <br><br>

            </td>
            <td>
              {{ candidato.avaliacao !== null && candidato.avaliacao !== undefined ? candidato.avaliacao : 'não avaliado' }}
            </td>

            <td>{{ candidato.email }}</td>
            <td>
              <a v-if="candidato.curriculoUrl" :href="candidato.curriculoUrl" target="_blank"
                :download="candidato.curriculoUrl.split('/').pop()">
                Ver Currículo
              </a>
              <span v-else>—</span>
            </td>
            <td>{{ formatarDataBrasileira(candidato.data_candidatura) }}</td>
            <!-- Novas colunas incrementadas -->
            <td>{{ candidato.dados?.telefone || '—' }}</td>
            <td>{{ candidato.dados?.cpf || '—' }}</td>
            <td>{{ candidato.dados?.endereco || '—' }}</td>
            <td>{{ candidato.dados?.cidade || '—' }}</td>
            <td>{{ candidato.dados?.estado || '—' }}</td>
            <td>{{ candidato.dados?.formacao || '—' }}</td>
            <td>{{ candidato.dados?.escolaridade || '—' }}</td>
            <td>{{ candidato.dados?.experiencia || '—' }}</td>
            <td>{{ candidato.dados?.genero || '—' }}</td>
            <td>{{ candidato.dados?.raca || '—' }}</td>
            <td>{{ candidato.dados?.deficiencia || '—' }}</td>
            <td>{{ candidato.dados?.nome_social || '—' }}</td>
            <td>{{ candidato.dados?.naturalidade || '—' }}</td>
            <td>{{ candidato.dados?.trabalhando_atualmente || '—' }}</td>
            <td>{{ candidato.dados?.data_nascimento || '—' }}</td>
            <td>{{ candidato.dados?.pretensao_salarial || '—' }}</td>
            <!-- Outras colunas já existentes, como ações -->
            <td>
              <!-- Exemplo de ação já existente -->
              <button class="btn btn-primary btn-sm" @click="verCandidato(candidato)">Ver</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p v-else class="text-muted">Nenhum candidato para esta vaga até o momento.</p>
  </div>
</template>

<script>
import api from '../services/api';
import * as XLSX from 'xlsx';
import JSZip from 'jszip';

export default {
  name: "CandidatosVagaVie",
  data() {
    return {
      candidatos: [],
      vaga: null,

      filtros: {
        nome: '',
        email: '',
        data_candidatura: '',
        telefone: '',
        cpf: '',
        endereco: '',
        cidade: '',
        estado: '',
        formacao: '',
        escolaridade: '',
        experiencia: '',
        genero: '',
        raca: '',
        deficiencia: '',
        nome_social: '',
        naturalidade: '',
        trabalhando_atualmente: '',
        data_nascimento: '',
        pretensao_salarial: ''
      }
    };
  },
  mounted() {
    const vagaId = this.$route.params.id;
    api.get(`candidatos_por_vaga.php?vaga_id=${vagaId}`)
      .then(res => {
        this.candidatos = (res.data || []).map(c => {
          // Ajusta o campo 'dados'
          const dados = typeof c.dados === 'string' ? JSON.parse(c.dados) : (c.dados || {});
          // Ajusta o caminho do currículo
          let curriculoUrl = '';
          if (c.caminho_arquivo) {
            const caminho = c.caminho_arquivo.startsWith('/')
              ? c.caminho_arquivo.slice(1)
              : c.caminho_arquivo;
            const backEndBase = `${window.location.protocol}//${window.location.host}/oportunidades-rh/backend/`;
            curriculoUrl = new URL(caminho, backEndBase).href;
          }
          return {
            ...c,
            dados,
            curriculoUrl
          };
        });
      })
      .catch(() => alert('Erro ao carregar candidatos.'));

    api.get(`buscar_vaga.php?id=${vagaId}`)
      .then(res => {
        if (res.data && res.data.id) {
          this.vaga = res.data;
        }
      })
      .catch(() => alert('Erro ao carregar dados da vaga.'));
  },
  computed: {
    candidatosFiltrados() {
      return this.candidatos.filter(c => {
        const d = c.dados || {};
        return (
          (!this.filtros.nome || c.nome?.toLowerCase().includes(this.filtros.nome.toLowerCase())) &&
          (!this.filtros.email || c.email?.toLowerCase().includes(this.filtros.email.toLowerCase())) &&
          (!this.filtros.data_candidatura || this.formatarDataBrasileira(c.data_candidatura).includes(this.filtros.data_candidatura)) &&
          (!this.filtros.telefone || d.telefone?.toLowerCase().includes(this.filtros.telefone.toLowerCase())) &&
          (!this.filtros.cpf || d.cpf?.toLowerCase().includes(this.filtros.cpf.toLowerCase())) &&
          (!this.filtros.endereco || d.endereco?.toLowerCase().includes(this.filtros.endereco.toLowerCase())) &&
          (!this.filtros.cidade || d.cidade?.toLowerCase().includes(this.filtros.cidade.toLowerCase())) &&
          (!this.filtros.estado || d.estado?.toLowerCase().includes(this.filtros.estado.toLowerCase())) &&
          (!this.filtros.formacao || d.formacao?.toLowerCase().includes(this.filtros.formacao.toLowerCase())) &&
          (!this.filtros.escolaridade || d.escolaridade?.toLowerCase().includes(this.filtros.escolaridade.toLowerCase())) &&
          (!this.filtros.experiencia || d.experiencia?.toLowerCase().includes(this.filtros.experiencia.toLowerCase())) &&
          (!this.filtros.genero || d.genero?.toLowerCase().includes(this.filtros.genero.toLowerCase())) &&
          (!this.filtros.raca || d.raca?.toLowerCase().includes(this.filtros.raca.toLowerCase())) &&
          (!this.filtros.deficiencia || d.deficiencia?.toLowerCase().includes(this.filtros.deficiencia.toLowerCase())) &&
          (!this.filtros.nome_social || d.nome_social?.toLowerCase().includes(this.filtros.nome_social.toLowerCase())) &&
          (!this.filtros.naturalidade || d.naturalidade?.toLowerCase().includes(this.filtros.naturalidade.toLowerCase())) &&
          (!this.filtros.trabalhando_atualmente || d.trabalhando_atualmente?.toLowerCase().includes(this.filtros.trabalhando_atualmente.toLowerCase())) &&
          (!this.filtros.data_nascimento || d.data_nascimento?.toLowerCase().includes(this.filtros.data_nascimento.toLowerCase())) &&
          (!this.filtros.pretensao_salarial || d.pretensao_salarial?.toLowerCase().includes(this.filtros.pretensao_salarial.toLowerCase()))
        );
      });
    },
  },
  methods: {
    emojiPorNota(nota) {
      const icones = ['😠', '🙁', '😐', '🙂', '😄'];
      return icones[nota - 1] || '❓';
    }
    ,
    formatarData(data) {
      return new Date(data).toLocaleDateString();
    },
    formatarDataBrasileira(data) {
      if (!data) return '—';
      // Troca espaço por 'T' para garantir compatibilidade
      const dataISO = data.replace(' ', 'T');
      const d = new Date(dataISO);
      if (isNaN(d)) return '—';
      return d.toLocaleDateString('pt-BR');
    },
    visualizarCurriculo() {
      window.open(this.curriculo.caminho, '_blank');
    },
    verCandidato(candidato) {
      // this.$router.push({ name: 'UsuarioPerfil', params: { id: candidato.id } });
      // Ou, se sua rota for diferente, ajuste o path:
      this.$router.push(`/admin/usuario/${candidato.id}`);
    },
    baixarXLSX() {
      // Ajuste para os dados que você exibe na tabela
     const dadosParaExportar = this.candidatosFiltrados.map(c => ({
  Nome: c.nome,
  Avaliação: c.avaliacao !== null && c.avaliacao !== undefined ? c.avaliacao : 'não avaliado',
  Email: c.email,
  'Data da Candidatura': this.formatarDataBrasileira(c.data_candidatura),
  Telefone: c.dados?.telefone || '',
  CPF: c.dados?.cpf || '',
  Endereço: c.dados?.endereco || '',
  Cidade: c.dados?.cidade || '',
  Estado: c.dados?.estado || '',
  Formação: c.dados?.formacao || '',
  Escolaridade: c.dados?.escolaridade || '',
  Experiência: c.dados?.experiencia || '',
  Gênero: c.dados?.genero || '',
  Raça: c.dados?.raca || '',
  'Pessoa com deficiência': c.dados?.deficiencia || '',
  'Nome Social': c.dados?.nome_social || '',
  Naturalidade: c.dados?.naturalidade || '',
  'Está trabalhando atualmente?': c.dados?.trabalhando_atualmente || '',
  'Data de Nascimento': c.dados?.data_nascimento || '',
  'Pretensão Salarial': c.dados?.pretensao_salarial || ''
}));


      const ws = XLSX.utils.json_to_sheet(dadosParaExportar);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Candidatos');
      XLSX.writeFile(wb, 'candidatos.xlsx');
    },
    async baixarTodosCurriculos() {
      const zip = new JSZip();
      const candidatosComCurriculo = this.candidatosFiltrados.filter(c => c.curriculoUrl);

      if (candidatosComCurriculo.length === 0) {
        alert('Nenhum currículo disponível para download.');
        return;
      }

      // Baixa cada currículo e adiciona ao zip
      for (const candidato of candidatosComCurriculo) {
        try {
          const response = await fetch(candidato.curriculoUrl);
          const blob = await response.blob();
          // Nome do arquivo: Nome_do_Candidato.extensão
          const nomeArquivo = (candidato.nome || 'curriculo') + '.' + (candidato.curriculoUrl.split('.').pop() || 'pdf');
          zip.file(nomeArquivo.replace(/\s+/g, '_'), blob);
        } catch (e) {
          // Se falhar, ignora este currículo
        }
      }

      // Gera o zip e faz download
      zip.generateAsync({ type: "blob" }).then(content => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(content);
        link.download = 'curriculos.zip';
        link.click();
        URL.revokeObjectURL(link.href);
      });
    },
  }
};
</script>
